module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('progress-bar', {
    attrs: {
      "percentage": _vm.generatePercantage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a98a6ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailStatus.vue
// module id = 284
// module chunks = 1